import React from "react";
import { Grid } from "@mui/material";

import Input from "../ReadOnlyInput";
import { formatMonetary, formatUpperCase } from "../../../../utils/formats";
import { Separator } from "../styles";

const InformacoesGarantiaSection = (props) => {
  const {
    proposalInfoWarrantyLoading,
    veiculo,
    ano,
    modelo,
    placa,
    uf,
    codigoFipe,
    valorMercado,
    chassi,
    debitosVeiculo,
    situacao,
  } = props;

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Input
                loading={proposalInfoWarrantyLoading}
                label="Veículo"
                value={veiculo}
              />
            </Grid>
            <Grid item xs={2}>
              <Input
                loading={proposalInfoWarrantyLoading}
                label="Ano/Modelo"
                value={ano && modelo ? `${ano}/${modelo}` : undefined}
              />
            </Grid>
            <Grid item xs={2}>
              <Input
                loading={proposalInfoWarrantyLoading}
                label="Placa/UF"
                value={placa && uf ? `${placa} ${uf}` : undefined}
              />
            </Grid>
            <Grid item xs={2}>
              <Input
                loading={proposalInfoWarrantyLoading}
                label="Código FIPE"
                value={codigoFipe}
              />
            </Grid>
            <Grid item xs={4}>
              <Input
                loading={proposalInfoWarrantyLoading}
                label="Valor de mercado"
                value={formatMonetary(valorMercado)}
              />
            </Grid>
            <Grid item xs={4}>
              <Input
                loading={proposalInfoWarrantyLoading}
                label="Chassi"
                value={chassi}
              />
            </Grid>
            <Grid item xs={4}>
              <Input
                loading={proposalInfoWarrantyLoading}
                label="Débitos do veículo"
                value={formatMonetary(debitosVeiculo)}
              />
            </Grid>
          </Grid>

          <Separator margin="20px" />

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Input
                type="textarea"
                height={200}
                loading={proposalInfoWarrantyLoading}
                label="Situação"
                value={formatUpperCase(situacao)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default InformacoesGarantiaSection;
